import { useIsExperimentalUser } from '@/authenticated/hooks/useIsExperimentalUser'

export function useMousePress() {
  // Kinda redundant, but makes finding usages easy
  return useIsExperimentalUser()
}
